import React from "react";
import {MutualBetslip} from "../../../features/betslip/mutual.service";
import {isSelectionRenderable} from "../selection-ready";
import {isMobile} from "../../../App";

export function BettingDataTabs(prop: any) {

    const selection = prop.selection;
    const selectBettingColumn = prop.selectBettingColumn;

    if (!isSelectionRenderable(selection)) {
        return (<></>)
    }


    let tabs: any = [];
    for (let i = Number(selection.bettingSubType.id); i < Number(selection.bettingSubType.id) + selection.bettingType.column; i += 1) {
        tabs.push(i)
    }

    let columnType = selection.bettingType.columnLabel === 'Koşu' ? 'run' : 'horse';
    let betSlipLegs = MutualBetslip.getLegsSelections();

    return (<>
        <div className="betting-run-tabs badge-tabs">
            {!isMobile && <div className={"weather-info"}>
                <p className={"text-xsmall text-bolder"}>{selection.hippodrome.location}</p>
                <>
                    <span className="text-xsmall text-bolder me-2">Hava: <span
                        className="text-xsmall">{selection.hippodrome.weather?.temperature} °C | {selection.hippodrome.weather?.forecast}</span></span>
                    <span className="text-xsmall text-bolder me-2">Nem: <span
                        className="text-xsmall">%{selection.hippodrome.weather?.humidity}</span></span>
                </>
            </div>}
            { tabs.length > 1 && <div className={"run-betting-tabs"}>

                {tabs.map((runNo: any, keyRun: number) => {
                    let columnNo = keyRun + 1;
                    return (
                        <div key={`runItem-${keyRun}`}
                             className={`run-betting-item ${columnNo === selection.column ? 'active justify-content-between' : 'justify-content-center'}`}
                             onClick={() => {
                                 selectBettingColumn(columnNo);
                                 try {
                                     const run = selection.hippodrome.runsMap[runNo] ?? {};
                                     // @ts-ignore
                                     dataLayer.push({
                                         event: "view_item",
                                         ecommerce:{
                                             currency: 'TRY',
                                             value: 0,
                                             items:[{
                                                 item_id : `${selection.bettingType.name} / ${selection.hippodrome.location} / ${selection.bettingSubType.label} / ${selection.hippodrome._date}`,
                                                 item_name: selection.bettingType.name,
                                                 item_brand: run.type_detail,
                                                 item_category: selection.hippodrome.location,
                                                 item_category2: selection.bettingSubType.label,
                                                 item_category3: selection.hippodrome._date,
                                                 item_category4: run.time,
                                                 item_category5: `${run.distance}m - ${run.course}`
                                             }]
                                         }
                                     })

                                 } catch (e) {

                                 }
                             }}>
                            {isMobile ?
                                <div className="mobile-run">
                                    <span
                                        className="text-small text-bolder">{columnType === 'run' ? selection.bettingSubType.label.split('-')[columnNo - 1] : columnNo}{columnNo === selection.column ? '.' :''}</span>
                                    {columnNo === selection.column && <span
                                        className="text-xxsmall"> {`${selection.bettingType.columnLabel}`}</span>}
                                </div>
                                : <div className="run">
                                <span
                                    className="text-xsmall text-bolder">{columnType === 'run' ? selection.bettingSubType.label.split('-')[columnNo - 1] : columnNo}.</span>
                                    <span
                                        className="text-xxsmall"> {selection.bettingType.columnLabel === 'Ayak' && isMobile ? columnNo === selection.column && `${selection.bettingType.columnLabel}` : `${selection.bettingType.columnLabel}`}</span>
                                </div>}
                            {isMobile && columnNo === selection.column && <span
                                className="badge">{betSlipLegs[keyRun].length > 0 ? betSlipLegs[keyRun].length : 0}</span>}

                        </div>)
                })}

            </div>}

        </div>
    </>)
}
